// src/pages/ForgotPasswordPage.js
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import Navbar from '../components/Navbar'
import SocialFooter from '../components/SocialFooter'
import './AuthPage.css'

export default function ForgotPasswordPage() {
  const [email, setEmail]   = useState('')
  const [sent, setSent]     = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError]   = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email.trim()) return
    setLoading(true); setError('')
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/reset-password`
    })
    setLoading(false)
    if (error) { setError(error.message); return }
    setSent(true)
  }

  return (
    <div className="auth-page">
      <Navbar />
      <div className="auth-wrap">
        <div className="auth-box">
          <div className="auth-box__header">
            <p className="auth-box__eyebrow">Account Recovery</p>
            <h1 className="auth-box__title">Reset Password</h1>
            <p className="auth-box__sub">{sent ? 'Check your email for the reset link' : 'Enter your email and we will send you a reset link'}</p>
          </div>
          {!sent ? (
            <form onSubmit={handleSubmit}>
              <div className="field">
                <label>Email Address</label>
                <input type="email" placeholder="your@email.com" value={email}
                  onChange={e => setEmail(e.target.value)} required autoComplete="email" />
              </div>
              {error && <div className="auth-error">{error}</div>}
              <button className="btn btn--gold btn--full" type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          ) : (
            <div style={{ textAlign:'center', padding:'8px 0 16px', display:'flex', flexDirection:'column', gap:14, alignItems:'center' }}>
              <div style={{ width:52, height:52, borderRadius:'50%', background:'rgba(92,154,114,0.1)', border:'1px solid rgba(92,154,114,0.4)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, color:'#4CAF7D' }}>✓</div>
              <p style={{ fontSize:14, color:'var(--cream)', lineHeight:1.7 }}>Reset link sent to <strong style={{color:'var(--gold)'}}>{email}</strong>. Check your inbox.</p>
              <p style={{ fontSize:12, color:'var(--dim)' }}>Check your spam folder if you don't see it.</p>
              <button className="btn btn--ghost btn--sm" onClick={() => setSent(false)}>Try again</button>
            </div>
          )}
          <p className="auth-switch">Remember it? <Link to="/login">Sign in →</Link></p>
        </div>
      </div>
      <SocialFooter />
    </div>
  )
}
